module.exports = __webpack_public_path__ + "static/media/iphone.075091c8.png";